import React, { Fragment } from 'react'
import { Outlet } from 'react-router-dom'
import Header from '../Components/Main/Header'
import Footer from '../Components/Main/Footer'

const Layout = () => {
    return (
        <Fragment>
            <Header />
            <Outlet />
            <Footer />
        </Fragment>
    )
}

export default Layout